export default __webpack_public_path__ + "static/media/1933.0039b813.png";